var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import PlusSvg from './plus.icon.svg';
export const PlusIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: PlusSvg }));
_react_refresh_temp_1 = PlusIcon;
$RefreshReg$(_react_refresh_temp_1, "PlusIcon");
